import React from 'react';
import { Settings, Link2, Bell, Shield, Mail } from 'lucide-react';

const SettingsTab = () => {
  return (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold text-gray-900">Sales module settings</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
          <div className="flex items-center gap-2 mb-4">
            <Link2 className="w-5 h-5 text-teal-600" />
            <h3 className="text-lg font-semibold text-gray-900">Integrations</h3>
          </div>
          <p className="text-sm text-gray-600 mb-4">
            Connect to Financial (credit, SOA, payments), Warehouse/Inventory (ATP, allocations), and Supply Chain (PRs, POs).
          </p>
          <ul className="space-y-2 text-sm text-gray-600">
            <li>• Financial: Credit limits, aging, draft receipts, SOA</li>
            <li>• Warehouse: ATP, reservations, order status</li>
            <li>• Supply Chain: Push PRs, view inbound POs</li>
          </ul>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
          <div className="flex items-center gap-2 mb-4">
            <Bell className="w-5 h-5 text-teal-600" />
            <h3 className="text-lg font-semibold text-gray-900">Alerts & notifications</h3>
          </div>
          <p className="text-sm text-gray-600 mb-4">
            Configure consumption alerts, credit hold notifications, and low-ATP warnings for reps.
          </p>
          <button className="px-3 py-1.5 bg-gray-100 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-200">
            Configure alerts
          </button>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
          <div className="flex items-center gap-2 mb-4">
            <Mail className="w-5 h-5 text-teal-600" />
            <h3 className="text-lg font-semibold text-gray-900">SOA & documents</h3>
          </div>
          <p className="text-sm text-gray-600 mb-4">
            Company branding for Statement of Account PDFs and default email templates.
          </p>
          <button className="px-3 py-1.5 bg-gray-100 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-200">
            Edit templates
          </button>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
          <div className="flex items-center gap-2 mb-4">
            <Shield className="w-5 h-5 text-teal-600" />
            <h3 className="text-lg font-semibold text-gray-900">Permissions</h3>
          </div>
          <p className="text-sm text-gray-600 mb-4">
            Control who can confirm orders, log payments, generate SOA, and push PRs to Supply Chain.
          </p>
          <button className="px-3 py-1.5 bg-gray-100 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-200">
            Manage roles
          </button>
        </div>
      </div>
    </div>
  );
};

export default SettingsTab;
